/* eslint-disable @typescript-eslint/no-explicit-any */
import MUIDataTable from "mui-datatables";
import { useContext, useEffect, useState } from "react";
import {  toast } from "react-toastify";import { DataTableState } from "../../Types/DataTableType";
import { Vocabulary } from "../../Utils/Vocabulary";
import { Delete, Edit } from "@mui/icons-material";
import {
  CircularProgress,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
} from "@mui/material";
import { getData } from "../../Services/getData";
import { LocalUrlEnum, UrlEnum } from "../../Utils/Utils";
import { deleteData } from "../../Services/deleteData";
import { useLocation, useNavigate } from "react-router-dom";
import DeleteQuestionnaireTemplateModal from "./DeleteQuestionnaireTemplateModal";
import { BreadCrumbsContext } from "../../Context/breadCrumbsContext";
import { breadCrumbsEnum } from "../../Utils/Constants";

export default function QuestionnairesTemplates() {
  const navigate = useNavigate();
  const location = useLocation();
  const [state, setState] = useState<DataTableState>({
    valuesPerPage: [],
    valuesNumber: 0,
    page: 1,
    perPage: 20,
    search: null,
    order: "asc",
    filter: null,
    loading: false,
  });
  const breadCrumbsContext = useContext(BreadCrumbsContext);
  const [deleteId, setDeleteId] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const notifyError = (message: string) => toast.error(message);
  const notifySuccess = (message: string) => toast.success(message);
  const userName = localStorage.getItem("userName")
    ? localStorage.getItem("userName")
    : "";

  useEffect(() => {
    breadCrumbsContext.setBreadCrumbs([
      `${breadCrumbsEnum.templates}/${breadCrumbsEnum.questionnaires}`,
    ]);

    const search = location.search.split("?");
    const newState = Object.assign({}, state) as any;
    search.forEach((value) => {
      if (value !== "") {
        const values = value.split("=");
        if (values[0] === "page") newState[values[0]] = +values[1] - 1;
        else newState[values[0]] = isNaN(+values[1]) ? values[1] : +values[1];
      }
    });
    getQuestionnaireTemplates(newState.page, newState.perPage, newState.search);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  /**
   *
   */
  async function getQuestionnaireTemplates(
    page: number,
    perPage: number,
    search?: string | null
  ) {
    setLoading(true);
    let url = `${UrlEnum.questionnaireTemplates}/${page}/${perPage}`;
    if (search) {
      url = `${UrlEnum.questionnaireTemplates}/${page}/${perPage}/${search}`;
    }
    await getData(url)
      .then((res) => {
        setState({
          ...state,
          valuesPerPage: res.data.questionnairesTemplates,
          valuesNumber: res.data.questionnairesTemplatesNumber,
          page: page,
          perPage: perPage,
          search: search || null,
        });
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        notifyError(Vocabulary.getError);
      });
  }

  /**
   *
   * @returns
   */
  function getTableOptions() {
    const responsive: "standard" | "vertical" | "simple" | undefined =
      "standard";
    return {
      selectableRows: "none" as any,
      viewColumns: false as any,
      responsive: responsive,
      rowsPerPageOptions: [10, 20, 50, 100],
      confirmFilters: true,
      filter: false,
      print: false,
      download: false,
      textLabels: {
        body: {
          noMatch: Vocabulary.noResultsFound,
        },
      },
      rowsPerPage: state.perPage,
      page: state.page,
      count: state.valuesNumber,
      search: true,
      serverSide: true,
      sort: true,
      setRowProps: () => {
        return {
          style: {
            cursor: "pointer",
          },
        };
      },
      onRowClick: (rowData: any, rowState: any) => {
        navigate(
          `${LocalUrlEnum.questionnairesTemplates}${
            state.valuesPerPage[rowState.rowIndex]._id
          }`
        );
      },
      onChangePage: (page: any) => {
        navigate(
          `${LocalUrlEnum.questionnairesTemplates}?page=${page + 1}?perPage=${
            state.perPage
          }`
        );
        window.scrollTo(0, 0);
      },
      onChangeRowsPerPage: (numberOfRows: number) => {
        navigate(
          `${
            LocalUrlEnum.questionnairesTemplates
          }?page=${1}?perPage=${numberOfRows}`
        );
        window.scrollTo(0, 0);
      },
      onSearchChange: async (search: string | null) => {
        if (search) {
          navigate(
            `${LocalUrlEnum.questionnairesTemplates}?page=${
              state.page + 1
            }?perPage=${state.perPage}?search=${search}`
          );
        } else {
          setState({ ...state, search: null });
          navigate(
            `${LocalUrlEnum.questionnairesTemplates}?page=${
              state.page + 1
            }?perPage=${state.perPage}`
          );
        }
      },
      onSearchClose: async () => {
        setState({ ...state, search: null });
        navigate(
          `${LocalUrlEnum.questionnairesTemplates}?page=${
            state.page + 1
          }?perPage=${state.perPage}`
        );
      },
    };
  }
  /**
   *
   */
  const dataTableHeader = [
    {
      label: Vocabulary.templateName.toUpperCase(),
      name: "templateName",
      options: {
        sort: false,
      },
    },
    {
      label: Vocabulary.options.toUpperCase(),
      name: "Optiuni",
      options: {
        setCellHeaderProps: () => ({
          align: "center",
        }),
        setCellProps: () => ({
          align: "center",
        }),
        filter: false,
        sort: false,

        empty: true,
        customBodyRenderLite: (dataIndex: any, rowIndex: any) => {
          return (
            <div
              style={{ marginTop: -10, marginBottom: -10, textAlign: "center" }}
            >
              <ToggleButtonGroup exclusive aria-label="text alignment">
                <Tooltip title={Vocabulary.edit}>
                  <ToggleButton
                    onClick={() => {
                      navigate(
                        `${LocalUrlEnum.questionnairesTemplates}${state.valuesPerPage[rowIndex]._id}`
                      );
                    }}
                    value="center"
                    aria-label="centered"
                  >
                    <Edit />
                  </ToggleButton>
                </Tooltip>
                <Tooltip title={Vocabulary.delete}>
                  <ToggleButton
                    onClick={(event) => {
                      event.stopPropagation();
                      setOpenDeleteModal(true);
                      setDeleteId(state.valuesPerPage[rowIndex]._id);
                    }}
                    value="center"
                    aria-label="centered"
                  >
                    <Delete />
                  </ToggleButton>
                </Tooltip>
              </ToggleButtonGroup>
            </div>
          );
        },
      },
    },
  ];

  /**
   *
   */
  function handleDelete() {
    setLoading(true);
    deleteData(`${UrlEnum.questionnaireTemplates}/${deleteId}/${userName}`)
      .then(async (res) => {
        await getQuestionnaireTemplates(
          state.page,
          state.perPage,
          state.search
        );
        setLoading(false);
        setOpenDeleteModal(false);
        notifySuccess(Vocabulary.deleteSuccess);
      })
      .catch((err) => {
        setLoading(false);
        setOpenDeleteModal(false);
        notifyError(Vocabulary.deleteError);
      });
  }

  return (
    <>
       <MUIDataTable
        title={Vocabulary.questionnairesTemplates}
        data={state.valuesPerPage}
        columns={dataTableHeader}
        options={getTableOptions()}
      />
      {openDeleteModal ? (
        <DeleteQuestionnaireTemplateModal
          openDeleteModal={openDeleteModal}
          setOpenDeleteModal={setOpenDeleteModal}
          handleDelete={handleDelete}
        />
      ) : (
        ""
      )}
      {loading ? (
        <div className="loading">
          <CircularProgress color="primary" />
        </div>
      ) : (
        ""
      )}
    </>
  );
}
